import { isEmpty } from "lodash";
import { useDispatch, useSelector } from "react-redux";
import { Modal, ModalBody, ModalHeader } from "react-bootstrap";

import TermsPublic from "../../pages/Public/TermsPublic/TermsPublic";
import { setUserAction } from "../../redux/actions/userActions/userActions";
import {
  setLoadingFalseAction,
  setLoadingTrueAction,
} from "../../redux/actions/loadingActions/loadingActions";
import { acceptTermsUserService } from "../../services/userServices";
import {
  toastErrorMessage,
  toastSuccessMessage,
} from "../../utils/toastMessage/toastMessage";

const Terms = () => {
  const dispatch = useDispatch();

  const user = useSelector((state) => state.user);

  // Accept Terms
  const handleAcceptTerms = async () => {
    try {
      dispatch(setLoadingTrueAction());
      const { status, data } = await acceptTermsUserService();
      if (status === 200) {
        toastSuccessMessage(data.resultMessage);
        dispatch(setUserAction());
      }
    } catch ({ response }) {
      if (response && response.status)
        toastErrorMessage(response.data.resultMessage);
    } finally {
      dispatch(setLoadingFalseAction());
    }
  };

  return (
    <Modal show={!isEmpty(user) && !user.termsAcceptedAt} size="xl">
      <ModalHeader>تایید قوانین و مقررات</ModalHeader>
      <ModalBody>
        <TermsPublic />
        <div className="text-end mt-3">
          <button
            className="btn btn-primary border border-primary-600 text-md px-56 py-12 radius-8"
            type="button"
            onClick={handleAcceptTerms}
          >
            تمامی قوانین و مقررات را می پذیرم
          </button>
        </div>
      </ModalBody>
    </Modal>
  );
};

export default Terms;
